import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserStoreService } from '@gah-core/services/user-store.service';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ApiPaths } from '@gah-core/constants/api-paths.enum';
import { AddToCartRequest } from '../models/add-to-cart.model';
import { GAHAppResponse } from '@data/schema/gah-app-response';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DigitalCartService {
  private readonly _cartItems = new BehaviorSubject<any>([]);
  readonly cartItems$ = this._cartItems.asObservable();

  private readonly _removeCartItems = new BehaviorSubject<any>([]);
  readonly removeCartItems$ = this._removeCartItems.asObservable();

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    private userStore: UserStoreService,
    private translate: TranslateService
  ) {}

  addToCart(request: AddToCartRequest): Observable<any> | null {
    return this.http
      .post<any>(`${environment.apiUrl}${ApiPaths.AddtoDigitalCart}`, request)
      .pipe(catchError((error) => this.handleError(error)));
  }

  removeItemsFromCart(request: AddToCartRequest): Observable<any> | null {
    return this.http
      .post<any>(`${environment.apiUrl}${ApiPaths.RemoveFromDigitalCart}`, request)
      .pipe(catchError((error) => this.handleError(error)));
  }

  getCartItems(): Observable<any> | null {
    let params = new HttpParams().set('userId', this.userStore.userState.userId);

    return this.http.get(`${environment.apiUrl}/${ApiPaths.GetCartAssetsInfo}`, { params }).pipe(
      map((res: GAHAppResponse) => {
        this._cartItems.next(res.serviceResult);
        return res;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  get cartItems(): any {
    return this._cartItems.getValue();
  }

  set cartItems(cartItemsUpdated: any) {
    this._cartItems.next(cartItemsUpdated);
  }

  get removeCartItems(): any {
    return this._removeCartItems.getValue();
  }

  set removeCartItems(removeCartItemsUpdated: any) {
    this._removeCartItems.next(removeCartItemsUpdated);
  }

  updateCartItems(cartItemsUpdated: any) {
    this._cartItems.next(cartItemsUpdated);
  }

  updateRemovedCartItems(removedCartItemsUpdated: number) {
    this._removeCartItems.next(removedCartItemsUpdated);
  }

  private handleError(error: HttpErrorResponse) {
    let errorMsg: {
      message: string;
      errorCode: number;
    } = {
      message: error.error.errorDescription
        ? error.error.errorDescription
        : this.translate.instant('unknown-error-msg-text'),
      errorCode: error.status,
    };
    return throwError(errorMsg);
  }
}
